import { render, staticRenderFns } from "./ProductFeedsForm.vue?vue&type=template&id=b1c638aa&scoped=true&"
import script from "./ProductFeedsForm.vue?vue&type=script&lang=js&"
export * from "./ProductFeedsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductFeedsForm.vue?vue&type=style&index=0&id=b1c638aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c638aa",
  null
  
)

export default component.exports